import React from "react";
import { Col, Container, Row, Modal, Card } from "react-bootstrap";
import Input, { PasswordInput } from "./Input";
import BackArrow from "../Assets/back-arrow.svg";
import ForwardArrow from "../Assets/forward-arrow.svg";
import Close from "../Assets/close.svg";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import PrimaryButton from "../util/Btns/PrimaryButton";
import { LargeCheckbox } from "../util/Btns/CheckboxBtnv1";
import Radio from "../util/Btns/RadioBtnv1";
import DevAuthAPI from "../api/DevAuth";
import { showLoader, hideLoader } from "../util/loader/CustomLoader";
import { CustomToast } from "../util/custom-toast/CustomToast";

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      step: 0,
      firstName: { value: "", warning: { msg: "", class: "" } },
      lastName: { value: "", warning: { msg: "", class: "" } },
      email: { value: "", warning: { msg: "", class: "" } },
      password: { value: "", warning: { msg: "", class: "" } },
      confirmPassword: { value: "", warning: { msg: "", class: "" } },
      phoneNumber: { value: "", warning: { msg: "", class: "" } },
      xrPlatform: [],
      xrPlatformOther: { active: false, value: "" },
      xrEngine: [],
      xrEngineOther: { active: false, value: "" },
      xrExperience: false,
      country: { list: [], selectedValue: null, warning: { msg: "", class: "" } },
      states: { list: [], selectedValue: null, warning: { msg: "", class: "" } },
      city: { list: [], selectedValue: null, warning: { msg: "", class: "" } },
      othCountry: { value: "", warning: { msg: "", class: "" } },
      othState: { value: "", warning: { msg: "", class: "" } },
      othCity: { value: "", warning: { msg: "", class: "" } },
    };
  }
  componentDidMount() {
    let api = new DevAuthAPI();
    api.getCountries()
      .then((response) => {
        let data = response.data.data;       
        this.setState({ country: { list: [...this.state.country.list, ...data], selectedValue: null, warning: { msg: "", class: "" } } })
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getStates(id) {

    let api = new DevAuthAPI();
    api.getStates(id)
      .then((response) => {
        let data = response.data.data;
        data.sort((a, b) => a.name.localeCompare(b.name))
        this.setState({ states: { list: [...this.state.states.list, ...data], selectedValue: null, warning: { msg: "", class: "" } } })
      })
      .catch((error) => {
        this.setState({
          states: { list: [], selectedValue: null, warning: { msg: "", class: "" } },
          city: { list: [], selectedValue: null, warning: { msg: "", class: "" } },
        })
      });
  }

  getCities(id) {
    let api = new DevAuthAPI();
    api.getCity(id)
      .then((response) => {
        let data = response.data.data;
        data.sort((a, b) => a.name.localeCompare(b.name))
        this.setState({ city: { list: [...this.state.city.list, ...data], selectedValue: null, warning: { msg: "", class: "" } } })
      })
      .catch((error) => {
        this.setState({
          city: { list: [], selectedValue: null, warning: { msg: "", class: "" } },
        })
      });
  }

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validateLowerCase(str) {
    const re = /(.*[a-z])/;
    return re.test(str);
  }
  validateUpperCase(str) {
    const re = /(.*[A-Z])/;
    return re.test(str);
  }
  validateDigit(str) {
    const re = /(.*\d)/;
    return re.test(str);
  }
  validateSymbol(str) {
    const re = /(.*\W)/;
    return re.test(str);
  }

  handlePasswordChange(e) {
    let tempState = { ...this.state.password };
    tempState.value = e.target.value;
    if (tempState.value.length === 0) {
      tempState.warning.msg = "";
      tempState.warning.class = "";
    } else if (tempState.value.length < 3) {
      tempState.warning.msg = "Weak";
      tempState.warning.class = "red";
    } else if (tempState.value.length < 8) {
      tempState.warning.msg = "Medium";
      tempState.warning.class = "yellow";
    } else if (tempState.value.length < 13) {
      tempState.warning.msg = "Strong";
      tempState.warning.class = "blue";
    } else {
      tempState.warning.msg = "Very Strong";
      tempState.warning.class = "green";
    }
    this.setState({ password: tempState });
  }

  handleConfirmPasswordChange(e) {
    let tempState = { ...this.state.confirmPassword };
    tempState.value = e.target.value;

   if (this.state.password.value !== tempState.value) {
      tempState.warning.msg = "Password Mismatch";
      tempState.warning.class = "red";
    } else {
      tempState.warning.msg = "";
      tempState.warning.class = "";
    }
    this.setState({ confirmPassword: tempState });
  }

  arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  }

  changeXRPlatform(e, value) {
    let allXRPlatforms = [...this.state.xrPlatform];
    if (e.target.checked) allXRPlatforms.push(value);
    else allXRPlatforms = this.arrayRemove(allXRPlatforms, value);

    this.setState({ xrPlatform: [...allXRPlatforms] });
    console.log(this.state.xrPlatform);
  }
  changeXREngine(e, value) {
    let allXREngine = [...this.state.xrEngine];
    if (e.target.checked) allXREngine.push(value);
    else allXREngine = this.arrayRemove(allXREngine, value);

    this.setState({ xrEngine: [...allXREngine] });
    console.log(this.state.xrEngine);
  }

  validateStepOneForm() {
    let validate = true;
    if (this.state.firstName.value.length < 3) {
      let tempState = { ...this.state.firstName };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Invalid First Name";
      this.setState({ firstName: tempState });
      validate = false;
    }
    if (!this.validateNameFormat(this.state.firstName.value)) {
      let tempState = { ...this.state.firstName };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Invalid First Name";
      this.setState({ firstName: tempState });
      validate = false;
    }
    if (this.state.lastName.value.length < 3) {
      let tempState = { ...this.state.lastName };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Invalid Last Name";
      this.setState({ lastName: tempState });
      validate = false;
    }
    if (!this.validateNameFormat(this.state.lastName.value)) {
      let tempState = { ...this.state.lastName };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Invalid Last Name";
      this.setState({ lastName: tempState });
      validate = false;
    }
    if (!this.validateEmail(this.state.email.value)) {
      let tempState = { ...this.state.email };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Invalid Email";
      this.setState({ email: tempState });
      validate = false;
    }
    if (this.state.password.value.length === 0) {
      let tempState = { ...this.state.password };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ password: tempState });
      validate = false;
    }
    if (this.state.password.value.length > 0 && this.state.password.value.length < 8) {
      let tempState = { ...this.state.password };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Minimum 8 Characters required";
      this.setState({ password: tempState });
      validate = false;
    }
    if (!this.validateLowerCase(this.state.password.value)) {
      let tempState = { ...this.state.password };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Must contain atleast one lowercase";
      this.setState({ password: tempState });
      validate = false;
      return;
    }
    if (!this.validateUpperCase(this.state.password.value)) {
      let tempState = { ...this.state.password };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Must contain atleast one uppercase";
      this.setState({ password: tempState });
      validate = false;
      return;
    }
    if (!this.validateDigit(this.state.password.value)) {
      let tempState = { ...this.state.password };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Must contain atleast one digit";
      this.setState({ password: tempState });
      validate = false;
      return;
    }
    if (!this.validateSymbol(this.state.password.value)) {
      let tempState = { ...this.state.password };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Must contain atleast one symbol";
      this.setState({ password: tempState });
      validate = false;
      return;
    }

    if (this.state.confirmPassword.value.length === 0) {
      let tempState = { ...this.state.confirmPassword };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ confirmPassword: tempState });
      validate = false;
    }

    if (this.state.confirmPassword.value.length > 0 && this.state.confirmPassword.value.length < 8) {
      let tempState = { ...this.state.confirmPassword };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Minimum 8 Characters required";
      this.setState({ confirmPassword: tempState });
      validate = false;
    }

    if (this.state.confirmPassword.value !== this.state.password.value)
      validate = false;

    if (!validate) {
      return;
    } else {
      this.setState({ step: 1 });
    }
  }

  validateStepTwoForm() {
    let validate = true;
    if (this.state.phoneNumber.value.length === 0 || !this.validateContact(this.state.phoneNumber.value)) {
      let tempState = { ...this.state.phoneNumber };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ phoneNumber: tempState });
      validate = false;
    }
if(this.state.country.selectedValue !== "OTH"){
    if (this.state?.country?.selectedValue===null) {
      let tempState = { ...this.state.country };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ country: tempState });
      validate = false;
    }
    if (this.state?.states?.selectedValue===null) {
      let tempState = { ...this.state.states };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ states: tempState });
      validate = false;
    }
    if (this.state?.city?.selectedValue===null) {
      let tempState = { ...this.state.city };
      tempState.warning.class = "border-red red";
      tempState.warning.msg = "Required";
      this.setState({ city: tempState });
      validate = false;
    }
  }
    if(this.state.country.selectedValue === "OTH"){
      if (this.state.othCountry.value.length === 0 || (this.state.othCountry.value && !this.validateNameFormat(this.state.othCountry.value))) {
        let tempState = { ...this.state.othCountry };
        tempState.warning.class = "border-red red";
        tempState.warning.msg = "Required";
        this.setState({ othCountry: tempState });
        validate = false;
      }
      if (this.state.othState.value.length === 0 || (this.state.othState.value && !this.validateNameFormat(this.state.othState.value))) {
        let tempState = { ...this.state.othState };
        tempState.warning.class = "border-red red";
        tempState.warning.msg = "Required";
        this.setState({ othState: tempState });
        validate = false;
      }
      if (this.state.othCity.value.length === 0 || (this.state.othCity.value && !this.validateNameFormat(this.state.othCity.value))) {
        let tempState = { ...this.state.othCity };
        tempState.warning.class = "border-red red";
        tempState.warning.msg = "Required";
        this.setState({ othCity: tempState });
        validate = false;
      }
    }
    if (!validate) return;
    this.submitSignup();
  }

  submitSignup() {
    console.log(this.state);
    var allXREngines = [...this.state.xrEngine];
    if (
      this.state.xrEngineOther.active &&
      this.state.xrEngineOther.value.length > 0
    )
      allXREngines.push(this.state.xrEngineOther.value);

    var allXRPlatforms = [...this.state.xrPlatform];
    if (
      this.state.xrPlatformOther.active &&
      this.state.xrPlatformOther.value.length > 0
    )
      allXRPlatforms.push(this.state.xrPlatformOther.value);

    showLoader();
    var api = new DevAuthAPI();
    console.log(this.state);
    api
      .developerSignUp({
        email: this.state.email.value,
        password: this.state.password.value,
        firstName: this.state.firstName.value,
        lastName: this.state.lastName.value,
        country: this.state.country.selectedValue === "OTH" ? this.state.othCountry.value : this.state.country.selectedValue,
        state: this.state.country.selectedValue === "OTH" ? this.state.othState.value : this.state.states.selectedValue,
        city: this.state.country.selectedValue === "OTH" ? this.state.othCity.value : this.state.city.selectedValue,
        phoneNumber: this.state.phoneNumber.value,
        xrExperience: this.state.xrExperience + "",
        xrEngine: allXREngines,
        xrPlatform: allXRPlatforms,
      })
      .then((response) => this.onSuccess(response))
      .catch((error) => this.onError(error));
  }

  onSuccess(response) {
    // handle success

    hideLoader();
    this.props.history.replace(`/verify-mail?email=${this.state.email.value}`);

    console.log(response);
  }
  onError(error) {
    hideLoader();
    CustomToast(error.response.data.message);
    // handle error
    console.log(error.response.data);
  }

  validateContact(contact) {
    const contactRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
    return contactRegex.test(contact)
  }

  validateNameFormat(name) {
    const re = /^(([a-z]{1,2})?|[.' ]){3}?([a-z]{3,})+$/i;
    return re.test(String(name));
  }

  handleClose = () => {
    localStorage.clear();
    this.props.history.replace("/");
  };


  handleHide=()=>{
    console.log('test')
  }

  render() {
    return (
      <React.Fragment>
        <Navbar showSignup={true} />

        <Container fluid className="main-container">
          <Modal
            show={true}
            centered
            size="md"
            contentClassName="login-modal pt-2"
            onHide={this.handleHide}
          >
            <Modal.Body>
              <Container>
                <Row>
                  <Col xs={10} md={11}>
                    <h4
                      style={{
                        color: "#FFFFFF",
                        fontSize: "1rem",
                        marginBottom: "0",
                      }}
                    >
                      Sign Up now
                    </h4>
                    <p className="sub-title">
                      <Link to="/login">
                        <p>
                          {"Sign In "}
                          <img
                            src={ForwardArrow}
                            alt="sfv"
                            height="7"
                            width="7"
                          />
                        </p>
                      </Link>
                    </p>
                  </Col>
                  <Col xs={2} md={1}>
                    <Link>
                      <img src={Close} height="14" width="14" alt="cross" onClick={() => this.handleClose()} />
                    </Link>
                  </Col>
                </Row>

                {this.state.step === 0 ? (
                  <div>
                    <Card
                      style={{
                        backgroundColor: "#101010",
                        padding: "0 1rem",
                        borderRadius: "8px",
                        margin: "0 -10px",
                      }}
                    >
                      <Row>
                        <Col xs={12} md={6}>
                          <Input
                            required="true"
                            label="First Name"
                            type="text"
                            name="first_name"
                            maxLen="30"
                            warning={this.state.firstName.warning}
                            value={this.state.firstName.value}
                            onChange={(e) => {
                              var tempState = {
                                ...this.state.firstName,
                              };
                              tempState.value = e.target.value;
                              this.setState({
                                firstName: tempState,
                              });
                              if (!e.target.value) {
                                tempState.warning.msg = "";
                                tempState.warning.class = "";
                              }
                              if (e.target.value.length < 3 && e.target.value.length > 0) {
                                tempState.warning.msg =
                                  "Minimum 3 characters required";
                                tempState.warning.class = "border-red red";
                              }
                              else if (!this.validateNameFormat(e.target.value) && e.target.value) {
                                tempState.warning.msg =
                                  "Invalid First Name";
                                tempState.warning.class = "border-red red";
                              }

                              else {
                                tempState.warning.msg = "";
                                tempState.warning.class = "";
                              }

                            }}
                            style={{
                              marginBottom: "-5px",
                            }}
                          />
                        </Col>

                        <Col xs={12} md={6}>
                          <Input
                            required="true"
                            label="Last Name"
                            type="text"
                            name="last_name"
                            maxLen="30"
                            value={this.state.lastName.value}
                            warning={this.state.lastName.warning}
                            onChange={(e) => {
                              var tempState = {
                                ...this.state.lastName,
                              };
                              tempState.value = e.target.value;
                              this.setState({
                                lastName: tempState,
                              });
                              if (!e.target.value) {
                                tempState.warning.msg = "";
                                tempState.warning.class = "";
                              }
                              if (e.target.value.length < 3 && e.target.value.length > 0) {
                                tempState.warning.msg =
                                  "Minimum 3 characters required";
                                tempState.warning.class = "border-red red";
                              }
                              else if (!this.validateNameFormat(e.target.value) && e.target.value) {
                                tempState.warning.msg =
                                  "Invalid Last Name";
                                tempState.warning.class = "border-red red";
                              }

                              else {
                                tempState.warning.msg = "";
                                tempState.warning.class = "";
                              }

                            }}
                            style={{
                              marginBottom: "-5px",
                            }}
                          />
                        </Col>

                        <Col xs={12} md={12}>
                          <Input
                            required="true"
                            label="Email ID"
                            type="email"
                            name="email"
                            maxLen="256"
                            warning={this.state.email.warning}
                            value={this.state.email.value}
                            onChange={(e) => {
                              var tempState = {
                                ...this.state.email,
                              };
                              tempState.value = e.target.value;

                              if (e.target.value.length === 0) {
                                tempState.warning.msg = "";
                                tempState.warning.class = "";
                              }
                              if (e.target.value.length < 6 && e.target.value.length > 0) {
                                tempState.warning.msg =
                                  "Minimum 6 characters required";
                                tempState.warning.class = "border-red red";
                              }

                              else if (!this.validateEmail(e.target.value) && e.target.value) {
                                tempState.warning.msg =
                                  "Invalid Email";
                                tempState.warning.class = "border-red red";
                              }
                              else
                                tempState.warning = {
                                  msg: "",
                                  class: "",
                                };
                              this.setState({
                                email: tempState,
                              });
                            }}
                            style={{
                              marginBottom: "-5px",
                            }}
                          />
                        </Col>

                        <Col xs={12} md={12}>
                          <PasswordInput
                            required="true"
                            validate={true}
                            label="Create Password"
                            type="password"
                            name="create_password"
                            maxLen="128"
                            warning={this.state.password.warning}
                            value={this.state.password.value}
                            onChange={(e) => {
                              let tempState = { ...this.state.password };
                              tempState.value = e.target.value;
                              tempState.warning = { msg: "", class: "" };
                              if (e.target.value.length < 8 && e.target.value.length > 0) {
                                tempState.warning = {
                                  msg: "Minimum 8 Characters Required",
                                  class: "border-red red",
                                };
                              }
                              this.handlePasswordChange(e)
                            }}
                            style={{
                              marginBottom: "00px",
                            }}
                          />
                        </Col>

                        <Col xs={12} md={12} style={{ marginTop: -10 }}>
                          <PasswordInput
                            required="true"
                            label="Confirm Password"
                            type="password"
                            name="confirm_password"
                            maxLen="128"
                            warning={this.state.confirmPassword.warning}
                            value={this.state.confirmPassword.value}
                            onChange={(e) => {
                              let tempState = { ...this.state.confirmPassword };
                              tempState.value = e.target.value;
                              tempState.warning = { msg: "", class: "" };
                              if (e.target.value.length < 8 && e.target.value.length > 0) {
                                tempState.warning = {
                                  msg: "Minimum 8 Characters Required",
                                  class: "border-red red",
                                };
                              }
                              this.handleConfirmPasswordChange(e)
                            }
                            }
                            style={{
                              marginBottom: "10px",
                            }}
                          />
                        </Col>
                      </Row>
                    </Card>
                    <Col
                      xs={9}
                      md={{ span: 4, offset: 10 }}
                      style={{
                        backgroundColor: "#1D1D1",
                      }}
                    >
                      <p className="sub-title next">
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            this.validateStepOneForm();
                          }}
                        >
                          <p>
                            {"Next "}
                            <img
                              alt=""
                              src={ForwardArrow}
                              height="12"
                              width="13"
                              style={{
                                marginTop: -2,
                              }}
                            />
                          </p>{" "}
                        </span>
                      </p>
                    </Col>
                  </div>
                ) : (
                  this.state.step === 1 && (
                    <div>
                      <Card
                        style={{
                          backgroundColor: "#101010",
                          padding: "0 1rem",
                          borderRadius: "8px",
                          margin: "0 -10px",
                          overflow:"auto"
                        }}
                      >
                        <div
                          className=""
                          style={{
                            maxHeight: "350px",
                          }}
                        >
                          <Row>
                            <Col xs={12} md={12}>
                              <Input
                                required="true"
                                label="Contact Number"
                                type="tel"
                                name="phoneNumber"
                                maxLen="13"
                                warning={this.state.phoneNumber.warning}
                                value={this.state.phoneNumber.value}
                                onChange={(e) => {
                                  var tempState = {
                                    ...this.state.phoneNumber,
                                  };
                                  tempState.value = e.target.value;
                                  this.setState({
                                    phoneNumber: tempState,
                                  });
                                  if (!e.target.value) {
                                    tempState.warning.msg = "";
                                    tempState.warning.class = "";
                                  }
                                  if (e.target.value.length < 10) {
                                    tempState.warning.msg =
                                      "Minimum 10 digits required";
                                    tempState.warning.class = "border-red red";
                                  }
                                  else if (!this.validateContact(e.target.value)) {
                                    tempState.warning.msg =
                                      "Invalid Contact Number";
                                    tempState.warning.class = "border-red red";
                                  }
                                  else {
                                    tempState.warning.msg = "";
                                    tempState.warning.class = "";
                                  }
                                }}
                                style={{
                                  marginBottom: "-5px",
                                }}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              style={{
                                marginBottom: "10px",
                              }}
                            >
                              <label className="xs-lable-select white select-arrow">
                                Country <span className="required-span">*</span>
                              </label>
                              <select
                                className="select-area white"
                                onChange={(e) => {
                                  this.setState({ ...this.state,country: { ...this.state.country, selectedValue: e.target[e.target.selectedIndex].getAttribute('name'), warning: { msg: "", class: "" } } });
                                  if(e.target[e.target.selectedIndex].getAttribute('name')===null) {
                                    this.setState({
                                      country: { ...this.state.country, selectedValue: null, warning: { msg: "", class: "" } },
                                      states: { list: [], selectedValue: null, warning: { msg: "", class: "" } },
                                      city: { list: [], selectedValue: null, warning: { msg: "", class: "" } },
                                    })
                                    this.setState({  
                                      states: { list: [], selectedValue: null, warning: { msg: "Error", class: "" } },
                                    })
                                  }
                                  if (this.state.country.selectedValue === "OTH") {
                                    this.setState({
                                      states: { list: [], selectedValue: null, warning: { msg: "", class: "" } },
                                      city: { list: [], selectedValue: null, warning: { msg: "", class: "" } },
                                    })
                                  }
                                  else {
                                    this.setState({
                                      othCountry: { value: "", warning: { msg: "", class: "" } },
                                      othState: { value: "", warning: { msg: "", class: "" } },
                                      othCity: { value: "", warning: { msg: "", class: "" } },
                                    })
                                  }
                                  this.setState({ states: { list: [], selectedValue: null, warning: { msg: "", class: "" } } })
                                  this.setState({ city: { list: [], selectedValue: null, warning: { msg: "", class: "" } } })
                                  this.getStates(e.target.value);
                                }}
                              >
                                <option>--Choose Country--</option>
                                {this.state.country?.list?.map((item, key) => {
                                  return (
                                    <option value={item?.id} name={item?.name} key={key}>
                                      {item.name}
                                    </option>
                                  );
                                })}
                                <option value="OTH" name="OTH">Other</option>
                              </select>
                              <span className="dropdown-span-error">{this.state.country.warning?.msg}</span>
                            </Col>
                            {this.state.country.selectedValue !== "OTH" &&
                              <>
                                <Col
                                  xs={12}
                                  md={12}
                                  style={{
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label className="xs-lable-select white select-arrow">
                                    State <span className="required-span">*</span>
                                  </label>
                                  <select
                                    className="select-area white"
                                    onChange={(e) => {
                                      this.setState({ states: { ...this.state.states, selectedValue: e.target[e.target.selectedIndex].getAttribute('name'), warning: { msg: "", class: "" } } });
                                      this.setState(
                                        { city: { list: [], selectedValue: null, warning: { msg: "", class: "" } } })
                                      this.getCities(e.target.value);
                                    }}
                                  >
                                    <option>--Choose State--</option>
                                    {this.state.states?.list?.map((item, key) => {
                                      return (
                                        <option value={item?.id} name={item?.name} key={key}>
                                          {item.name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <span className="dropdown-span-error">{this.state.states.warning?.msg}</span>
                                </Col>
                                <Col
                                  xs={12}
                                  md={12}
                                  style={{
                                    marginBottom: "10px",
                                  }}
                                >
                                  <label className="xs-lable-select white select-arrow">
                                    City <span className="required-span">*</span>
                                  </label>
                                  <select
                                    className="select-area white"
                                    onChange={(e) => {
                                      this.setState({
                                        city: { ...this.state.city, selectedValue: e.target[e.target.selectedIndex].getAttribute('name'),  warning: { msg: "", class: "" } }
                                      });
                                    }}
                                  >
                                    <option>--Choose City--</option>
                                    {this.state.city?.list?.map((item, key) => {
                                      return (
                                        <option value={item?.id} name={item?.name} key={key}>
                                          {item.name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  <span className="dropdown-span-error">{this.state.city.warning?.msg}</span>
                                </Col></>
                            }
                            {this.state.country.selectedValue === "OTH" &&
                              <>
                                <Input
                                  required={true}
                                  label="Country"
                                  type="text"
                                  name="country"
                                  maxLen={30}
                                  warning={this.state.othCountry.warning}
                                  value={this.state.othCountry.value}
                                  className=" "
                                  onChange={(e) => {
                                    let tempState = {
                                      ...this.state.othCountry
                                    };

                                    tempState.value = e.target.value;

                                    if (!e.target.value) {
                                      tempState.warning.msg = "";
                                      tempState.warning.class = "";
                                    }
                                    if (e.target.value.length < 3) {
                                      tempState.warning.msg =
                                        "Minimum 3 characters required";
                                      tempState.warning.class = "border-red red";
                                    }
                                    else if (!this.validateNameFormat(e.target.value)) {
                                      tempState.warning.msg =
                                        "Invalid Format";
                                      tempState.warning.class = "border-red red";
                                    }
                                    else {
                                      tempState.warning.msg = "";
                                      tempState.warning.class = "";
                                    }
                                    this.setState({
                                      othCountry: tempState,
                                    });
                                  }}
                                  style={{
                                    marginBottom: "-5px",
                                  }}
                                />
                                <Input
                                  required={true}
                                  label="State"
                                  type="text"
                                  name="state"
                                  maxLen={30}
                                  warning={this.state.othState.warning}
                                  value={this.state.othState.value}
                                  className=""
                                  onChange={(e) => {
                                    let tempState = {
                                      ...this.state.othState
                                    };
                                    tempState.value = e.target.value;
                                    this.setState({
                                      othState: tempState,
                                    });
                                    if (!e.target.value) {
                                      tempState.warning.msg = "";
                                      tempState.warning.class = "";
                                    }
                                    if (e.target.value.length < 3) {
                                      tempState.warning.msg =
                                        "Minimum 3 characters required";
                                      tempState.warning.class = "border-red red";
                                    }
                                    else if (!this.validateNameFormat(e.target.value)) {
                                      tempState.warning.msg =
                                        "Invalid Format";
                                      tempState.warning.class = "border-red red";
                                    }
                                    else {
                                      tempState.warning.msg = "";
                                      tempState.warning.class = "";
                                    }
                                  }}
                                  style={{
                                    marginBottom: "-5px",
                                  }}
                                />
                                <Input
                                  required={true}
                                  label="City"
                                  type="text"
                                  name="city"
                                  maxLen={30}
                                  warning={this.state.othCity.warning}
                                  value={this.state.othCity.value}
                                  className=""
                                  onChange={(e) => {
                                    let tempState = {
                                      ...this.state.othCity
                                    };
                                    tempState.value = e.target.value;
                                    this.setState({
                                      othCity: tempState,
                                    });
                                    if (!e.target.value) {
                                      tempState.warning.msg = "";
                                      tempState.warning.class = "";
                                    }
                                    if (e.target.value.length < 3) {
                                      tempState.warning.msg =
                                        "Minimum 3 characters required";
                                      tempState.warning.class = "border-red red";
                                    }
                                    else if (!this.validateNameFormat(e.target.value)) {
                                      tempState.warning.msg =
                                        "Invalid Format";
                                      tempState.warning.class = "border-red red";
                                    }
                                    else {
                                      tempState.warning.msg = "";
                                      tempState.warning.class = "";
                                    }
                                  }}
                                />
                              </>}

                            <Col
                              xs={12}
                              md={12}
                              style={{
                                marginBottom: "10px",
                              }}
                            >
                              <label className="xs-lable-select white">
                                Do you have experience in developing AR/VR/MR
                                application?
                              </label>
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Radio
                                id="yes"
                                label="Yes"
                                name="experience"
                                onChange={(e) => {
                                  this.setState({
                                    xrExperience: true,
                                  });
                                }}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Radio
                                id="no"
                                label="No"
                                name="experience"
                                onChange={(e) => {
                                  this.setState({
                                    xrExperience: false,
                                  });
                                }}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              style={{
                                marginBottom: "10px",
                                marginTop: "15px",
                              }}
                            >
                              <label className="xs-lable-select white">
                                Do you have published applications on any of the
                                following XR Platforms ?
                              </label>
                            </Col>
                            <Col
                              xs={12}
                              md={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <LargeCheckbox
                                label="Oculus"
                                id="oculus"
                                onChange={(e) =>
                                  this.changeXRPlatform(e, "Oculus")
                                }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <LargeCheckbox
                                label="HTC Vive"
                                id="htc"
                                onChange={(e) =>
                                  this.changeXRPlatform(e, "HTC Vive")
                                }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <LargeCheckbox
                                label="Microsoft Hololens"
                                id="microsoft"
                                onChange={(e) =>
                                  this.changeXRPlatform(e, "Microsoft Hololens")
                                }
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <LargeCheckbox
                                label="Magic Leap"
                                id="magic-leap"
                                onChange={(e) =>
                                  this.changeXRPlatform(e, "Magic Leap")
                                }
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <LargeCheckbox
                                label="NReal"
                                id="nreal"
                                onChange={(e) =>
                                  this.changeXRPlatform(e, "NReal")
                                }
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <LargeCheckbox
                                label="Mobile AR"
                                id="mobile-ar"
                                onChange={(e) =>
                                  this.changeXRPlatform(e, "Mobile AR")
                                }
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <LargeCheckbox
                                label="Others"
                                id="others"
                                onChange={(e) => {
                                  var tempState = {
                                    ...this.state.xrPlatformOther,
                                  };
                                  if (e.target.checked) tempState.active = true;
                                  else {
                                    tempState.value = "";
                                    tempState.active = false;
                                  }
                                  this.setState({
                                    xrPlatformOther: tempState,
                                  });
                                }}
                              />
                              <input
                                className="other-input"
                                type="text"
                                value={this.state.xrPlatformOther.value}
                                onChange={(e) => {
                                  var tempState = {
                                    ...this.state.xrPlatformOther,
                                  };
                                  tempState.value = e.target.value;
                                  this.setState({
                                    xrPlatformOther: tempState,
                                  });
                                }}
                                disabled={!this.state.xrPlatformOther.active}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={12}
                              style={{
                                marginBottom: "10px",
                              }}
                            >
                              <label className="xs-lable-select white">
                                Which game engine do you build on?
                              </label>
                            </Col>
                            <Col
                              xs={12}
                              md={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <LargeCheckbox
                                label="Unity"
                                id="unity"
                                onChange={(e) =>
                                  this.changeXREngine(e, "Unity")
                                }
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <LargeCheckbox
                                label="Unreal"
                                id="unreal"
                                onChange={(e) =>
                                  this.changeXREngine(e, "Unreal")
                                }
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={12}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 10,
                              }}
                            >
                              <LargeCheckbox
                                label="Others"
                                id="others2"
                                onChange={(e) => {
                                  var tempState = {
                                    ...this.state.xrEngineOther,
                                  };
                                  if (e.target.checked) tempState.active = true;
                                  else {
                                    tempState.value = "";
                                    tempState.active = false;
                                  }
                                  this.setState({
                                    xrEngineOther: tempState,
                                  });
                                }}
                              />
                              <input
                                className="other-input"
                                value={this.state.xrEngineOther.value}
                                onChange={(e) => {
                                  var tempState = {
                                    ...this.state.xrEngineOther,
                                  };
                                  tempState.value = e.target.value;
                                  this.setState({
                                    xrEngineOther: tempState,
                                  });
                                }}
                                type="text"
                                disabled={!this.state.xrEngineOther.active}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Card>
                      <Row className="mt-2 mb-2">
                        <Col xs={9}>
                          <p className="sub-title back">
                            <span
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  step: 0,
                                  xrPlatform: [],
                                  xrPlatformOther: { active: false, value: "" },
                                  xrEngine: [],
                                  xrEngineOther: { active: false, value: "" },
                                });
                              }}
                            >
                              <p>
                                <img
                                  alt=""
                                  style={{
                                    marginTop: -3,
                                  }}
                                  src={BackArrow}
                                  height="12"
                                  width="15"
                                />
                                {" Back"}
                              </p>
                            </span>
                          </p>
                        </Col>
                        <Col xs={3} className="btm-view-login">
                          {/* <Link to="/verify-mail"> */}

                          <PrimaryButton
                            onClick={(e) => { this.validateStepTwoForm(); }}
                          >
                            Submit
                          </PrimaryButton>
                          {/* </Link> */}
                        </Col>
                      </Row>
                    </div>
                  )
                )}
              </Container>
            </Modal.Body>
          </Modal>
        </Container>
      </React.Fragment>
    );
  }
}

export default SignUp;
